import { render } from "./UserDrilldownDialog.vue?vue&type=template&id=454b1afd&ts=true"
import script from "./UserDrilldownDialog.vue?vue&type=script&lang=ts"
export * from "./UserDrilldownDialog.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__